import React from 'react'
import { Text } from '@chakra-ui/react'

export const CompletionMessage = () => (
  <Text fontSize="md" fontWeight="600" color="label.primary" lineHeight="22px" textAlign="center">
    コインの購入が完了しました。
  </Text>
)
